import { camelize, getDateTypeIndex } from '@src/packages/dashboard/utils';

const AUX_FIELDS_BY_SECOND_DIMENSION = {
  'user.id': {
    key: 'user',
    values: ['user.firstName', 'user.lastName'],
  },
  'location.id': {
    key: 'location',
    values: ['location.name'],
  },
  'trigger.id': {
    key: 'trigger',
    values: ['trigger.name'],
  },
};

export const transformCountChartData = (result, filters, intl, chartGroupBy, queryParams) => {
  let { data: agg } = camelize(result);
  
  if (!agg) {
    return {
      data: {
        metrics: [],
        dimensionKeys: [],
        info: { totalEvents: 0 },
      },
      additionalState: { barColors: {} },
    };
  }

  const total = agg?.hits?.total?.value ?? 0;
  const buckets = agg?.aggregations?.eventsCount?.buckets;
  
  if (!buckets || !Array.isArray(buckets)) {
    return {
      data: {
        metrics: [],
        dimensionKeys: [],
        info: { totalEvents: total },
      },
      additionalState: { barColors: {} },
    };
  }
  
  agg = buckets;

  const formatedData = agg.map(({ key, docCount, secondDimension: pSecondDimension }) => {
    const transformedItem = {
      key: getDateTypeIndex(key, chartGroupBy, intl),
      count: docCount,
    };

    if (pSecondDimension?.buckets?.length > 0) {
      pSecondDimension.buckets.forEach(dim => {
        transformedItem[`dimension_${dim.key}`] = dim.docCount;
      });
    }
    return transformedItem;
  });

  const { secondDimension } = queryParams || {};
  const secondDimensionAux = AUX_FIELDS_BY_SECOND_DIMENSION[secondDimension];

  const dimensionKeys = Array.from(
    agg.reduce((set, item) => {
      item?.secondDimension?.buckets?.forEach(dim => {
        const secondDimensionSource = dim?.secondDimensionFields?.hits?.hits[0]?.source ?? null;
        const secondDimensionName = Object.values(
          secondDimensionSource?.[secondDimensionAux?.key] || {},
        )
          .filter(Boolean)
          .join(', ');

        if (!Array.from(set).find(i => i.key === dim.key)) {
          set.add({ key: dim.key, name: secondDimensionName });
        }
      });
      return set;
    }, new Set()),
  );

  return {
    data: {
      metrics: formatedData,
      dimensionKeys,
      info: { totalEvents: total },
    },
    additionalState: { barColors: {} },
  };
};

